const index = () => import('./Index');

//建立云南省惠企政策申报系统平台
export default {
  routes: [
    {
      path: '/smes/policy/v2021/index',
      name: 'smes_policy_2021_index',
      component: index,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/smes/policy/v2021/router.js